import Request from "../utils/request";
import SecureRequest, { apiPost, apiPut } from "../utils/securerequest";

export function* changeUserPassword(payload) {
  const { currentPassword, password } = payload;
  // Backend-owned (no Cognito in the browser): the session identifies the user;
  // an-api verifies the current password and sets the new one.
  return yield apiPut("/users/me/change-password", {
    currentPassword,
    newPassword: password,
  });
}

export function* migrate(params) {
  return yield Request.post(`/users/migrate`, params);
}

export function* getInvitation(guid) {
  return yield Request.get(`/invitations/${guid}`);
}

/**
 * Complete a setup-link invitation through the backend (no client-side Cognito):
 * an-api sets the permanent password, establishes a `.foo.com` session cookie,
 * and marks the invitation used. Returns routing info (authorityName, userId,
 * clientId, name/phone) for the post-setup step.
 */
export function* completeInvitation({ guid, password }) {
  return yield apiPost(`/invitations/${guid}/complete`, { password });
}

export function* markInvitationUsed(guid) {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return yield Request.put(`/invitations/${guid}`, {});
}

export function* verify(email, params) {
  return yield Request.post(`/customers/${email}/verify`, params);
}
